module.exports = __webpack_public_path__ + "img/contents_market_main_01.cc33690.png";